export default __webpack_public_path__ + "static/media/IconSync.299733c0.svg";